import { DeliveryIcon, PickupIcon } from 'assets/icons';
import BadgeLabel from 'components/BadgeLabel';
import { FOODHUB, OMNI_MIGRATION_DRIVER } from 'constants/migrationTypes';
import React from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';

export const getOrderType = (order) => {
  const trackingLink = order?.external_order_details?.tracking_link || 
                      order?.dispatcher_dropoff_tracking_link || 
                      order?.dispatcher_pickup_tracking_link;
  
  if (trackingLink) {
    return (
      <a 
        href={trackingLink} 
        target="_blank" 
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        style={{ display: 'inline-block' }}
      >
        <BadgeLabel
          label={order?.has_delivery ? "Delivery" : "Pick Up"}
          leadingIcon={<ArrowRightOutlined style={{ transform: 'rotate(-45deg)' }} />}
          classes="type-size p-1"
        />
      </a>
    );
  }
  
  return order?.has_delivery ? (
    <BadgeLabel
      label="Delivery"
      leadingIcon={<DeliveryIcon />}
      classes="type-size p-1"
    />
  ) : (
    <BadgeLabel
      label="Pick Up"
      leadingIcon={<PickupIcon />}
      classes="type-size p-1"
    />
  );
};

export const isEzCaterOrder = ({ migration_driver: driver, source } = {}) => (
  driver === 'EzCater' || source === 'ezCater'
);

export const isFoodHubSelfDelivery = ({ migration_driver: driver, source } = {}) => (
  (driver === FOODHUB && source?.toUpperCase() !== 'MERCHANT WEBSITE')
);
export const isOmniPartner = ({ migration_driver: driver, merchant: { is_partner: isPartner } = {} } = {}) => isOmni(driver) && isPartner;
export const isOmni = (driver) => OMNI_MIGRATION_DRIVER.includes(driver);
export const getItemValue = ({ value, migrationDriver }) => {
  switch (migrationDriver) {
  case 'DD':
    return value.replace('$', '');
  case 'FH':
    return value / 100;
  default:
    return value;
  }
};
